import React, { useRef } from "react";
import Draggable from "react-draggable";
import { X } from "lucide-react";
import useModalStore from "../../stores/modalStore";

const modalKey = (name) => `show${name.charAt(0).toUpperCase()}${name.slice(1)}`;

const GenericModal = ({
                          name,
                          title = "Modal",
                          children,
                          buttonText = "Open Modal",
                          buttonClass = "px-4 py-2 bg-blue-600 text-white rounded",
                          modalMaxWidth = "max-w-2xl",
                          modalProps = {},
                          hideButton = false,
                          stickyFooter = null,
                      }) => {
    const dragRef = useRef(null);

    const show = useModalStore(state => state[modalKey(name)]);
    const openModal = useModalStore(state => state.openModal);
    const closeModal = useModalStore(state => state.closeModal);

    return (
        <>
            {!hideButton && (
                <button
                    className={buttonClass}
                    onClick={() => openModal(name, modalProps)}
                >
                    {buttonText}
                </button>
            )}

            {show && (
                <div className="fixed inset-0 bg-black/40 backdrop-blur-sm flex items-center justify-center z-50 p-4">
                    <Draggable handle=".modal-drag-handle" cancel="button" nodeRef={dragRef}>
                        <div
                            ref={dragRef}
                            className={`bg-white rounded-2xl shadow-xl w-full ${modalMaxWidth} max-h-[90vh] flex flex-col overflow-hidden`}
                            style={{ cursor: "default" }}
                        >
                            {/* Header */}
                            <div className="flex justify-between items-center px-6 py-4 border-b border-gray-100 modal-drag-handle cursor-move select-none">
                                <h2 className="text-lg font-bold text-gray-800">{title}</h2>
                                <button
                                    onClick={() => closeModal(name)}
                                    className="!p-1.5 !bg-transparent !border !border-gray-200 !rounded-lg hover:!bg-gray-100 !text-gray-400 hover:!text-gray-600 !transition-colors"
                                >
                                    <X size={16} />
                                </button>
                            </div>

                            {/* Body */}
                            <div className="overflow-y-auto flex-grow">
                                {children}
                            </div>

                            {/* Sticky footer (optional) */}
                            {stickyFooter && (
                                <div className="border-t border-gray-100 px-6 py-3 bg-white sticky bottom-0">
                                    {stickyFooter}
                                </div>
                            )}
                        </div>
                    </Draggable>
                </div>
            )}
        </>
    );
};

export default GenericModal;
